import { useEffect, useState } from "react";
import Brand from "../../assets/img/logo-horizontal.png";
import { Image } from "react-bootstrap";
import "./styles.scss";

export default function Splash() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000); // 3 segundos

    return () => clearTimeout(timer);
  }, []);

  if (!showSplash) return null;

  return (
    <div className="splash d-flex justify-content-center align-items-center bg-primary">
      <Image src={Brand} fluid />
    </div>
  );
}
